<script lang="ts">
  import StatusTag from "@kontextwerk/web-sdk/ui/display/StatusTag.svelte"
  import { RICH_TOOLTIP_CLASS } from "../../../../../../../../../../../_shared/_logic/rich-tooltips"
  import type { PlanningPreviewRow } from "../../../../../../_shared/_logic/table-contract"

  type Props = {
    row: PlanningPreviewRow
  }

  const { row }: Props = $props()
</script>

<StatusTag
  variant="neutral"
  size="sm"
  label={row.propertyTag.label}
  subLabel={row.propertyTag.subLabel ?? undefined}
  color={row.propertyTag.color}
  icon={row.propertyTag.icon}
  tooltipContent={row.propertyTag.tooltip ?? ""}
  tooltipHtml={true}
  tooltipClassName={RICH_TOOLTIP_CLASS}
  disableTitle={true}
/>
